import { useEffect, useState } from "react";
import { Modal } from "@/components/ui/Modal";
import { Button } from "@/components/ui/Button";

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: (motivo: string) => Promise<void>;
  loading?: boolean;
  title?: string;
}

export function SolicitacaoPagamentoReprovarModal({
  open,
  onClose,
  onConfirm,
  loading,
  title = "Reprovar solicitação",
}: Props) {
  const [motivo, setMotivo] = useState("");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!open) {
      setMotivo("");
      setError(null);
    }
  }, [open]);

  const handleConfirm = async () => {
    const trimmed = motivo.trim();
    if (!trimmed) {
      setError("Informe o motivo da reprovação.");
      return;
    }
    setError(null);
    await onConfirm(trimmed);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      size="md"
      footer={
        <div className="flex items-center justify-end gap-2 w-full">
          <Button variant="ghost" onClick={onClose} disabled={loading}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={() => void handleConfirm()} loading={loading}>
            Confirmar reprovação
          </Button>
        </div>
      }
    >
      <div className="space-y-3">
        <p className="text-sm text-slate-600">
          Informe o motivo da reprovação. A solicitação retornará à etapa inicial.
        </p>
        <div className="flex flex-col gap-1.5">
          <label
            htmlFor="reprovar-motivo"
            className="text-xs font-semibold text-slate-500 uppercase tracking-wide"
          >
            Motivo *
          </label>
          <textarea
            id="reprovar-motivo"
            value={motivo}
            onChange={(e) => {
              setMotivo(e.target.value);
              if (error) setError(null);
            }}
            rows={4}
            autoFocus
            className="w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-brand-600 focus:border-brand-600"
            placeholder="Descreva o motivo da reprovação"
          />
        </div>
        {error && <p className="text-sm text-red-600">{error}</p>}
      </div>
    </Modal>
  );
}
